import Product from '../models/Product';

const mockData = [
  new Product(
    'SS002',
    'Trenton modular sofa_3',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Sofas',
    ['Sofa', 'Chair', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss002_1.png'),
    [require('../../assets/svgs/ss002_1.png')],
  ),
  new Product(
    'SS003',
    'Granite dining table with dining chair',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Tables',
    ['Chair', 'Home', 'Shop', 'Table'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss003_1.png'),
    [require('../../assets/svgs/ss003_1.png')],
  ),
  new Product(
    'SS004',
    'Outdoor bar table and stool',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Tables',
    ['Chair', 'Home', 'Shop', 'Table'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss004_1.png'),
    [require('../../assets/svgs/ss004_1.png')],
  ),
  new Product(
    'SS005',
    'Plain console with teak mirror',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Consoles',
    ['Consoles', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss005_1.png'),
    [require('../../assets/svgs/ss005_1.png')],
  ),
  new Product(
    'SS006',
    'Grain coffee table',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Tables',
    ['Table', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss006_1.png'),
    [require('../../assets/svgs/ss006_1.png')],
  ),
  new Product(
    'SS007',
    'Kent coffee table',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Tables',
    ['Table', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss007_1.png'),
    [require('../../assets/svgs/ss007_1.png')],
  ),
  new Product(
    'SS008',
    'Round coffee table_color 2',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Tables',
    ['Table', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss008_1.png'),
    [require('../../assets/svgs/ss008_1.png')],
  ),
  new Product(
    'SS009',
    'Reclaimed teak coffee table',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Tables',
    ['Table', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss009_1.png'),
    [require('../../assets/svgs/ss009_1.png')],
  ),
  new Product(
    'SS010',
    'Plain console',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Consoles',
    ['Console', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss010_1.png'),
    [require('../../assets/svgs/ss010_1.png')],
  ),
  new Product(
    'SS011',
    'Reclaimed teak sideboard',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Sofas',
    ['Sofa', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss011_1.png'),
    [require('../../assets/svgs/ss011_1.png')],
  ),
  new Product(
    'SS012',
    'SJP_0825',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Chairs',
    ['Chair', 'Home', 'Garden'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss012_1.png'),
    [require('../../assets/svgs/ss012_1.png')],
  ),
  new Product(
    'SS013',
    'Bella chair and table',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Chairs',
    ['Chair', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss013_1.png'),
    [require('../../assets/svgs/ss013_1.png')],
  ),
  new Product(
    'SS014',
    'Granite square side table',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Tables',
    ['Table', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss014_1.png'),
    [require('../../assets/svgs/ss014_1.png')],
  ),
  new Product(
    'SS001',
    'Asgaard Sofa',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Sofas',
    ['Sofa', 'Chair', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    4.2,
    [],
    require('../../assets/svgs/ss001_1.png'),
    [
      require('../../assets/svgs/ss001_1.png'),
      require('../../assets/svgs/ss001_2.png'),
      require('../../assets/svgs/ss001_3.png'),
      require('../../assets/svgs/ss001_4.png'),
      require('../../assets/svgs/ss001_5.png'),
    ],
  ),
  new Product(
    'SS015',
    'Maya sofa three seater',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Sofas',
    ['Sofa', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss015_1.png'),
    [require('../../assets/svgs/ss015_1.png')],
  ),
  new Product(
    'SS016',
    'Outdoor sofa set',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Sofas',
    ['Sofa', 'Garden', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss016_1.png'),
    [require('../../assets/svgs/ss016_1.png')],
  ),
  new Product(
    'SS017',
    'Trenton modular sofa_3',
    'Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound.',
    25000,
    'Sofas',
    ['Sofa', 'Chair', 'Home', 'Shop'],
    ['#816DFA', '#000000', '#CDBA7B'],
    ['L', 'XL', 'XS'],
    null,
    [],
    require('../../assets/svgs/ss017_1.png'),
    [require('../../assets/svgs/ss017_1.png')],
  ),
];

export default mockData;
